import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_PARAMETRIZACAO = [
  {
    module: 'USER',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'name'
      },
      {
        active: true,
        removable: true,
        field: 'email'
      },
      {
        active: true,
        removable: true,
        field: 'settings.info_app_version'
      }
    ]
  },
  {
    module: 'PROTOCOLOS',
    colunas: [
      { field: 'codigo', active: true, removable: true },
      { field: 'nome', active: true, removable: false }
    ]
  },
  {
    module: 'PROCEDIMENTOS',
    colunas: [
      { field: 'codigo', active: true, removable: true },
      { field: 'nome', active: true, removable: false },
      { field: 'tipo_procedimento.descricao', active: true, removable: true },
      // { field: 'valor', active: true, removable: true }
    ]
  },
  {
    module: 'PLANOS_SAUDE',
    colunas: [
      { field: 'codigo', active: true, removable: true },
      { field: 'descricao', active: true, removable: false },
      { field: 'protocolo', active: true, removable: true },
      { field: 'valor', active: true, removable: true }
    ]
  },
  {
    module: 'MOTIVO_CANCELAMENTO',
    colunas: [
      { field: 'codigo', active: true, removable: false },
      { field: 'descricao', active: true, removable: false },
    ]
  }
] as IColunasSettingsUser[];
